import { makeRoute } from './makeRoute';

/**
 * Mirrors `giftMethods` in libs/gift-wizard/src/state/atoms.ts. The wizard's
 * parser drops an unknown value, so a stale name here lands on the method
 * picker rather than erroring.
 */
export type GiftMethod = 'cash' | 'crypto' | 'grant' | 'stock';

export type GiftLink = {
  /** Leave unset to land on the wizard's own method picker. */
  method?: GiftMethod;
  /** In cents, and only sent for cash. See below. */
  cashAmountCents?: number;
};

/**
 * The app's front door with the gift wizard already open.
 *
 * The gw_* keys are declared in libs/gift-wizard/src/state/url-parsers.ts, and
 * spelled out here rather than imported, because this file has to stay clear of
 * nuqs for routes/server to carry it. Keep the three names in step with that
 * file: the wizard builds shareable links out of them.
 */
export const gift = makeRoute((args: GiftLink) => {
  const params = new URLSearchParams({ gw_open: 'true' });
  if (args.method !== undefined) params.set('gw_method', args.method);

  /*
   * An amount only rides along with cash. The wizard measures stock in shares and
   * crypto in tokens, and its own link builder drops a cash amount on any other
   * method anyway.
   */
  if (args.method === 'cash' && args.cashAmountCents !== undefined && args.cashAmountCents > 0) {
    params.set('gw_cash_amount_cents', String(Math.round(args.cashAmountCents)));
  }

  return `/?${params.toString()}`;
}, 'app');
